import gql from 'graphql-tag';

const ALL_CITIES_QUERY = gql`
  query AllCities($locale: CityLocale!) {
    cities {
      id
      cityName(locale: $locale)
      minimumStaying
      relevance
      country {
        countryId
      }
      currencyIsoCode
    }
  }
`;

export const getAllCities = client => locale =>
  client.query({ query: ALL_CITIES_QUERY, variables: { locale } });

export default {
  getAllCities
};
